import { userRegisterApi } from "src/domain/api/user/userRegisterApi"

export async function userRegisterService(payload: {
	mobileNo: string
	password: string
}) {
	return await userRegisterApi(payload)
}
